export const common = {
  // Navigation
  home: 'Accueil',
  dashboard: 'Tableau de bord',
  cars: 'Voitures',
  agencies: 'Agences',
  brands: 'Marques',
  about: 'À propos',
  contact: 'Contact',
  signIn: 'Se connecter',
  signUp: 'S\'inscrire',
  login: 'Se connecter',
  signup: 'S\'inscrire',
  logout: 'Déconnexion',
  myAccount: 'Mon compte',
  dashboardNav: 'Tableau de bord',
  
  // Location search
  location: 'Lieu',
  pickupDate: 'Date de prise en charge',
  returnDate: 'Date de retour',
  selectDates: 'Sélectionner les dates',
  day: 'jour',
  time: 'Heure',
  from: 'À partir de',
  
  // Homepage content
  findBookRental: 'Trouvez, Réservez, Louez',
  easySteps: 'étapes faciles',
  getCarWherever: 'Obtenez une voiture partout',
  howItWork: 'Comment ça marche',
  rentWithSteps: 'Louez en 3 étapes faciles',
  whyChooseUs: 'Pourquoi nous choisir',
  bestExperienceRental: 'Meilleure expérience de location',
  popularRentalDeals: 'Offres de location populaires',
  mostPopularCars: 'Voitures les plus populaires',
  rent: 'Louer',
  showAllVehicles: 'Voir tous les véhicules',
  testimonials: 'Témoignages',
  whatPeopleSay: 'Ce que disent les gens',
  
  // Steps
  chooseLocation: 'Choisir l\'emplacement',
  chooseLocationDesc: 'Sélectionnez votre lieu de prise en charge',
  pickupDateDesc: 'Choisissez votre date de prise en charge',
  bookYourCar: 'Réservez votre voiture',
  bookYourCarDesc: 'Complétez votre réservation',
  
  // Benefits
  bestPriceGuaranteed: 'Meilleur prix garanti',
  bestPriceGuaranteedDesc: 'Nous offrons les meilleurs prix',
  experienceDriver: 'Conducteur expérimenté',
  experienceDriverDesc: 'Conducteurs professionnels',
  carDelivery24h: 'Livraison de voiture 24h',
  carDelivery24hDesc: 'Service de livraison 24/7',
  technicalSupport247: 'Support technique 24/7',
  technicalSupport247Desc: 'Support en continu',
  
  // Common actions
  search: 'Rechercher',
  filter: 'Filtrer',
  book: 'Réserver',
  cancel: 'Annuler',
  confirm: 'Confirmer',
  save: 'Enregistrer',
  saving: 'Enregistrement...',
  saveChanges: 'Enregistrer les modifications',
  saved: 'Enregistré avec succès',
  refresh: 'Actualiser',
  edit: 'Modifier',
  delete: 'Supprimer',
  loading: 'Chargement...',
  unknownError: 'Erreur inconnue',
  submit: 'Soumettre',
  close: 'Fermer',
  back: 'Retour',
  goBack: 'Retour',
  next: 'Suivant',
  clear: 'Effacer',
  change: 'Changer',
  manageColumns: 'Gérer les Colonnes',
  selectColumnsToDisplay: 'Sélectionnez les colonnes à afficher dans le tableau',
  resetDefault: 'Réinitialiser par Défaut',
  previous: 'Précédent',
  yes: 'Oui',
  no: 'Non',
  ok: 'OK',
  optional: 'Optionnel',
  none: 'Aucun',
  amount: 'Montant',
  noLocationsFound: 'Aucun lieu trouvé',
  user: 'Utilisateur',
  
  // Status
  status: 'Statut',
  active: 'Actif',
  inactive: 'Inactif',
  pending: 'En attente',
  confirmed: 'Confirmé',
  completed: 'Terminé',
  cancelled: 'Annulé',
  
  // Signup Section
  joinKiraCar: 'Rejoindre KiraCar',
  chooseYourPath: 'Choisissez votre voie et commencez votre voyage avec la meilleure plateforme de location de voitures',
  becomeClient: 'Devenir Client',
  clientDescription: 'Louez des voitures facilement et rapidement. Accédez à une large gamme de véhicules disponibles près de chez vous.',
  signupAsClient: 'S\'inscrire comme Client',
  becomeAgency: 'Devenir Agence',
  agencyDescription: 'Listez votre flotte et développez votre entreprise de location',
  signupAsAgency: 'S\'inscrire comme Agence',
  
  // Time
  today: "Aujourd'hui",
  yesterday: 'Hier',
  tomorrow: 'Demain',
  thisMonth: 'Ce Mois',
  last7Days: '7 Derniers Jours',
  last30Days: '30 Derniers Jours',
  allPeriod: 'Toutes les Périodes',
  customPeriod: 'Période Personnalisée',
  customPeriodEllipsis: 'Période Personnalisée...',
  selectCustomPeriod: 'Sélectionner Période Personnalisée',
  startDate: 'Date de Début',
  endDate: 'Date de Fin',
  pickDate: 'Choisir une date',
  apply: 'Appliquer',
  minute: 'minute',
  minutes: 'minutes',
  hour: 'heure',
  hours: 'heures',
  days: 'jours',
  week: 'semaine',
  weeks: 'semaines',
  month: 'mois',
  months: 'mois',
  year: 'année',
  years: 'années',
  
  // Common phrases
  noDataFound: 'Aucune donnée trouvée',
  tryAgain: 'Réessayer',
  somethingWentWrong: 'Quelque chose s\'est mal passé',
  pleaseWait: 'Veuillez patienter...',
  
  // Languages
  english: 'English',
  french: 'Français',
  arabic: 'العربية',
  
  // Common statuses
  available: 'Disponible',
  unavailable: 'Indisponible',
  
  // Common
  view: 'Voir',
  welcome: 'Bienvenue',
  error: 'Erreur',
  retry: 'Réessayer',
  
  // Error and Alert Messages
  warning: 'Avertissement',
  info: 'Information',
  
  // Booking Alerts
  pleaseSelectDates: 'Veuillez sélectionner les dates de prise en charge et de retour',
  failedToCreateBooking: 'Échec de la création de la réservation. Veuillez réessayer.',
  carNotFound: 'Voiture non trouvée',
  backToCars: 'Retour aux voitures',
  
  // Location Management Alerts
  locationTableNotExists: 'La table agency_locations n\'existe pas encore. Veuillez exécuter le script SQL fourni dans complete_location_system_setup.sql',
  databaseError: 'Erreur de base de données: {{message}}. Code: {{code}}',
  errorSavingLocation: 'Erreur lors de l\'enregistrement du lieu. Vérifiez la console pour plus de détails.',
  errorSettingDefaultLocation: 'Erreur lors de la définition du lieu principal. Vérifiez la console pour plus de détails.',
  
  // Contract Alerts
  errorDownloadingContract: 'Erreur lors du téléchargement du contrat',
  errorPrintingContract: 'Erreur lors de l\'impression du contrat',
  
  // Booking
  booking: {
    contactInfo: 'Informations de contact',
    contactInfoDescription: 'Veuillez fournir vos coordonnées pour finaliser votre réservation',
    confirmBooking: 'Confirmer la réservation',
    processing: 'Traitement en cours...',
    bookingCreated: 'Réservation créée !',
    agencyWillContactYou: 'L\'agence vous contactera bientôt sur WhatsApp',
    keepPhoneAvailable: 'Veuillez garder votre téléphone disponible',
    bookingDetails: 'Détails de la réservation',
    bookingId: 'N° de réservation',
    createAccountBenefit: '🎁 Créez un compte pour suivre vos réservations !',
    trackAllBookings: 'Suivez toutes vos réservations au même endroit',
    viewHistory: 'Consultez l\'historique et les reçus',
    fasterNextTime: 'Réservez plus rapidement la prochaine fois',
    manageProfile: 'Gérez votre profil et vos préférences',
    createAccountNow: 'Créer un compte maintenant',
    maybeLater: 'Peut-être plus tard',
    createYourAccount: 'Créez votre compte',
    accountPreFilled: 'Vos informations de contact sont déjà renseignées',
    skipForNow: 'Passer pour le moment',
    goToDashboard: 'Accéder au tableau de bord',
  },

  // Authentication
  auth: {
    fullName: 'Nom complet',
    enterFullName: 'Entrez votre nom complet',
    phone: 'Téléphone',
    enterPhone: 'Entrez votre numéro de téléphone',
    email: 'E-mail',
    enterEmail: 'Entrez votre adresse e-mail',
    password: 'Mot de passe',
    enterPassword: 'Entrez votre mot de passe',
    passwordMinLength: 'Minimum 6 caractères',
    passwordTooShort: 'Le mot de passe doit contenir au moins 6 caractères',
    invalidEmail: 'Format d\'e-mail invalide',
    createAccount: 'Créer un compte',
    creatingAccount: 'Création du compte...',
    accountCreated: 'Compte créé !',
    accountCreatedSuccess: 'Votre compte a été créé avec succès. Vous pouvez maintenant suivre vos réservations et gérer votre profil.',
    login: 'Se connecter',
    alreadyHaveAccount: 'Vous avez déjà un compte ?',
  },
  
  // Customer Management
  failedToDeleteCustomer: 'Échec de la suppression du client: {{message}}',
  areYouSureYouWantToDeleteThisCustomer: 'Êtes-vous sûr de vouloir supprimer ce client? Cette action ne peut pas être annulée.',
  
  // Vehicle Management
  failedToUploadImage: 'Échec du téléchargement de l\'image: {{fileName}}\\nErreur: {{error}}',
  searchVehicle: 'Rechercher un véhicule...',
  
  // Profile Settings
  profileSettings: 'Paramètres du profil',
  manageProfileInfo: 'Gérez vos informations de profil et préférences',
  profilePicture: 'Photo de profil',
  uploadProfilePicture: 'Téléchargez une photo de profil pour personnaliser votre compte',
  personalInformation: 'Informations personnelles',
  personalInfoDescription: 'Mettez à jour vos détails personnels et informations de contact',
  updatePersonalDetails: 'Mettez à jour vos détails personnels et informations de contact',
  fullName: 'Nom complet',
  fullNamePlaceholder: 'Entrez votre nom complet',
  emailAddress: 'Adresse e-mail',
  emailCannotBeChanged: "L'e-mail ne peut pas être modifié",
  emailCannotChange: "L'adresse e-mail ne peut pas être modifiée pour des raisons de sécurité",
  phoneNumber: 'Numéro de téléphone',
  clientType: 'Type de client',
  individual: 'Particulier',
  company: 'Entreprise',
  identityInformation: "Informations d'identité",
  identityCardNumber: "Numéro de carte d'identité (CIN)",
  drivingPermitNumber: 'Numéro de permis de conduire',
  companyInformation: "Informations de l'entreprise",
  iceNumber: 'Numéro ICE',
  iceNumberPlaceholder: "Identifiant d'entreprise à 15 chiffres",
  updateProfile: 'Mettre à jour le profil',
  updating: 'Mise à jour...',
  profileUpdatedSuccessfully: 'Profil mis à jour avec succès!',
  profilePictureUpdatedSuccessfully: 'Photo de profil mise à jour avec succès!',
  failedToUpdateProfile: 'Échec de la mise à jour du profil',
  
  // Password Management
  security: 'Sécurité',
  changePassword: 'Changer le Mot de Passe',
  passwordHelp: 'Mettez à jour votre mot de passe pour sécuriser votre compte',
  currentPassword: 'Mot de Passe Actuel',
  newPassword: 'Nouveau Mot de Passe',
  confirmPassword: 'Confirmer le Mot de Passe',
  updatePassword: 'Mettre à Jour le Mot de Passe',
  passwordChanged: 'Mot de passe modifié avec succès !',
  passwordUpdateFailed: 'Échec de la mise à jour du mot de passe',
  currentPasswordRequired: 'Le mot de passe actuel est requis',
  newPasswordRequired: 'Le nouveau mot de passe est requis',
  confirmPasswordRequired: 'Veuillez confirmer votre nouveau mot de passe',
  passwordTooShort: 'Le mot de passe doit contenir au moins 6 caractères',
  passwordMismatch: 'Les mots de passe ne correspondent pas',
  incorrectCurrentPassword: 'Le mot de passe actuel est incorrect',
  fillAllFields: 'Veuillez remplir tous les champs',
  
  // Coming Soon
  somethingAmazing: 'Quelque chose d\'Incroyable',
  isComingSoon: 'Arrive Bientôt',
  workingHardToDeliver: "Nous travaillons dur pour vous offrir l'expérience ultime de location de voitures.",
  stayTuned: 'Restez à l\'écoute pour les mises à jour!',
  comingSoon: 'Bientôt Disponible',
  
  // Customer Dashboard
  bookNewCar: 'Réserver une nouvelle voiture',
  browseAgencies: 'Parcourir les agences',
  support: 'Support',
  totalBookings: 'Total des réservations',
  noBookingsYet: 'Aucune réservation pour le moment',
  startExploring: 'Commencez à explorer nos voitures pour faire votre première réservation!',
  recentBookings: 'Réservations récentes',
  viewDetails: 'Voir les détails',
  
  // Agency Dashboard Menu
  clients: 'Clients',
  bookings: 'Réservations',
  selectPickupLocation: 'Sélectionner le lieu de prise en charge',
  selectReturnLocation: 'Sélectionner le lieu de retour',
  selectPickupLocationError: 'Veuillez sélectionner un lieu de prise en charge',
  selectReturnLocationError: 'Veuillez sélectionner un lieu de retour',
  currentVehicleLocation: 'Emplacement actuel du véhicule',
  locationFixed: 'Fixe',
  selectCarFirst: 'Sélectionnez d\'abord un véhicule',
  carNoLocation: 'Ce véhicule n\'a pas d\'emplacement assigné',
  calendar: 'Calendrier',
  invoices: 'Factures',
  reports: 'Rapports',
  agencyDashboard: 'Tableau de bord agence',
  
  // Car Details
  seats: 'Places',
  description: 'Description',
  features: 'Caractéristiques',
  rentalAgency: 'Agence de location',
  bookThisCar: 'Réserver cette voiture',
  additionalNotes: 'Notes supplémentaires (Optionnel)',
  additionalNotesPlaceholder: 'Exigences spéciales ou notes...',
  dailyRate: 'Tarif journalier',
  duration: 'Durée',
  total: 'Total',
  bookNow: 'Réserver maintenant',
  processing: 'Traitement...',
  needToSignIn: 'Vous devez',
  toBookThisCar: 'pour réserver cette voiture',
  
  // Settings
  settings: {
    title: 'Paramètres de l\'Agence',
    subtitle: 'Gérez les informations et préférences de votre agence',
    general: 'Général',
    locations: 'Lieux',
    business: 'Business',
    notifications: 'Notifications',
    saving: 'Sauvegarde...',
    savedSuccessfully: 'Paramètres sauvegardés avec succès',
    errorSaving: 'Erreur lors de la sauvegarde',
    agencyInformation: 'Informations de l\'Agence',
    agencyInformationDesc: 'Mettez à jour les détails et informations de contact de votre agence',
    agencyLogo: 'Logo de l\'Agence',
    uploadLogo: 'Télécharger le Logo',
    logoRecommendation: 'Recommandé: 200x200px, PNG ou JPG',
    agencyName: 'Nom de l\'Agence',
    agencyNamePlaceholder: 'Nom de Votre Agence',
    email: 'Email',
    emailPlaceholder: 'contact@votreagence.com',
    phone: 'Téléphone',
    phonePlaceholder: '+33 1 23 45 67 89',
    country: 'Pays',
    countryPlaceholder: 'France',
    city: 'Ville',
    cityPlaceholder: 'Paris',
    address: 'Adresse',
    addressPlaceholder: '123 Rue Principale',
    description: 'Description',
    descriptionPlaceholder: 'Brève description de votre agence...',
    saveChanges: 'Sauvegarder les Modifications',
    financialSettings: 'Paramètres Financiers',
    financialSettingsDesc: 'Configurez vos préférences de tarification et financières',
    currency: 'Devise',
    selectCurrency: 'Sélectionner la Devise',
    taxRate: 'Taux de Taxe (%)',
    taxRatePlaceholder: '0.0',
    workingHours: 'Heures de Travail',
    workingHoursDesc: 'Définissez les heures d\'ouverture de votre agence',
    open: 'Ouvert',
    to: 'à',
    contractTemplate: 'Modèle de Contrat',
    contractTemplateDesc: 'Personnalisez votre modèle de contrat de location',
    defaultContractTemplate: 'Modèle de Contrat par Défaut',
    contractTemplatePlaceholder: 'Entrez votre modèle de contrat...',
    saveBusinessSettings: 'Sauvegarder les Paramètres Business',
    notificationPreferences: 'Préférences de Notification',
    notificationPreferencesDesc: 'Configurez comment vous recevez les notifications',
    emailNotifications: 'Notifications Email',
    emailNotificationsDesc: 'Recevoir les notifications par email',
    bookingConfirmations: 'Confirmations de Réservation',
    bookingConfirmationsDesc: 'Être notifié quand les réservations sont confirmées',
    paymentReminders: 'Rappels de Paiement',
    paymentRemindersDesc: 'Recevoir les notifications de rappel de paiement',
    maintenanceAlerts: 'Alertes de Maintenance',
    maintenanceAlertsDesc: 'Recevoir les alertes pour la maintenance des véhicules',
    enabled: 'Activé',
    disabled: 'Désactivé',
    saveNotificationSettings: 'Sauvegarder les Paramètres de Notification',
    days: {
      monday: 'Lundi',
      tuesday: 'Mardi',
      wednesday: 'Mercredi',
      thursday: 'Jeudi',
      friday: 'Vendredi',
      saturday: 'Samedi',
      sunday: 'Dimanche',
    },
  },
  
  // Contracts
  contracts: {
    title: 'Gestion des Contrats',
    subtitle: 'Créez et gérez vos contrats de location',
    createContract: 'Créer un Contrat',
    createFirstContract: 'Créer votre premier contrat',
    generateContract: 'Générer le Contrat',
    contractPreview: 'Aperçu du Contrat',
    preview: 'Aperçu',
    download: 'Télécharger',
    searchPlaceholder: 'Rechercher par numéro de contrat, client...',
    noContracts: 'Aucun contrat trouvé',
    noContractsDesc: 'Commencez par créer votre premier contrat de location',
    noContractsFound: 'Aucun contrat trouvé',
    tryDifferentSearch: 'Essayez une recherche différente',
    selectBooking: 'Sélectionnez une réservation pour créer un contrat',
    noBookingsAvailable: 'Aucune réservation confirmée disponible',
    createdOn: 'Créé le',
    totalAmount: 'Montant total',
    signed: 'Signé',
    pending: 'En attente',
    contractNumber: 'Numéro de contrat',
    client: 'Client',
    vehicle: 'Véhicule',
    period: 'Période',
    amount: 'Montant',
    creationDate: 'Date création',
    status: 'Statut',
    actions: 'Actions',
    deposit: 'Caution',
    to: 'au',
    phone: 'Téléphone',
    email: 'E-mail',
    date: 'Date',
    startDate: 'Date de début',
    endDate: 'Date de fin',
    agencyRepresentative: 'Représentant de l\'agence',
    renter: 'Locataire',
    rentalPeriod: 'PÉRIODE DE LOCATION',
    financialTerms: 'CONDITIONS FINANCIÈRES',
    signatureAgreement: 'En signant ci-dessous, les deux parties acceptent les termes et conditions énoncés ci-dessus.',
    totalRentalAmount: 'Montant total de location',
    depositAmount: 'Montant de la caution',
    make: 'Marque',
    model: 'Modèle',
    year: 'Année',
    color: 'Couleur',
    rentalAgreement: 'CONTRAT DE LOCATION',
    vehicleDetails: 'DÉTAILS DU VÉHICULE',
    termsAndConditions: 'TERMES ET CONDITIONS',
    agency: 'l\'Agence',
    renterName: 'le Locataire',
    agreementBetween: 'Ce contrat est conclu entre',
    and: 'et',
    clientContact: 'INFORMATIONS DE CONTACT DU CLIENT',
    fullName: 'Nom complet',
  },
  
  // Date Range Selector
  selectPeriod: 'Sélectionner une période',
  selectAPeriod: 'Sélectionner une période',
  selectTime: 'Sélectionner une heure',
  
  // Booking Timeline Calendar
  selectStatus: 'Sélectionner un statut',
  pickupTime: 'Heure de retrait',
  returnTime: 'Heure de retour',
  timeCaption: 'Heure',
  notSpecified: 'Non spécifiée',
  
  // Labels
  vehicle: 'Véhicule',
  vehicles: 'Véhicules',
  vehicleAvailable: 'véhicule disponible',
  vehiclesAvailable: 'véhicules disponibles',
  category: 'catégorie',
  categories: 'catégories',
  bookingCalendar: 'Calendrier des Réservations',
  
  // Date formatting
  invalidFormat: 'Format invalide',
  dateError: 'Erreur de date',
  
  // Common UI text
  unknownClient: 'Client inconnu',
  noVehicleFound: 'Aucun véhicule trouvé',
  noVehicleFoundFor: 'Aucun véhicule trouvé pour',
  
  // Pagination
  showing: 'Affichage de',
  to: 'à',
  of: 'sur',
  rowsPerPage: 'Lignes par page',
  
  // Customer info
  customerInformation: 'Informations Client',
  idNumber: 'CIN',
  phoneLabel: 'Tél',
  vehicleNotFound: 'Véhicule non trouvé',
  
  // File upload errors
  invalidFileType: 'Type de fichier invalide. Veuillez télécharger un fichier image.',
  fileTooLarge: 'Le fichier est trop volumineux. Veuillez télécharger une image de moins de 5 Mo.',
  logoUploadError: 'Échec du téléchargement du logo',
  
  // Date and time
  selectDate: 'Sélectionner une date',
  
  // Additional booking keys
  totalPrice: 'Prix Total',
  paymentStatus: 'Statut de Paiement',
  paid: 'Payé',
  unpaid: 'Non Payé',
  notes: 'Notes',
  noNotes: 'Aucune note',
  notesPlaceholder: 'Ajouter des notes...',
  pickupLocation: 'Lieu de Prise en Charge',
  returnLocation: 'Lieu de Retour',
  selectVehicle: 'Sélectionner un Véhicule',
  
  // Notifications
  notifications: {
    title: 'Notifications',
    empty: 'Aucune notification',
    emptyDescription: 'Lorsque vous recevrez des mises à jour, elles apparaîtront ici',
    unreadCount: '{{count}} notifications non lues',
    markAsRead: 'Marquer comme lu',
    markAllRead: 'Tout marquer comme lu',
    dismiss: 'Ignorer',
    types: {
      booking: 'Réservation',
      maintenance: 'Maintenance',
      insurance: 'Assurance',
      payment: 'Paiement',
      system: 'Système'
    },
    priorities: {
      normal: 'Normal',
      important: 'Important',
      urgent: 'Urgent'
    },
    templates: {
      pickupReminder: {
        title: 'Rappel de Prise en Charge - {{carMake}} {{carModel}}',
        message: 'Le client {{customerName}} doit récupérer le véhicule dans 4 heures.'
      },
      returnReminder: {
        title: 'Rappel de Retour - {{carMake}} {{carModel}}',
        message: 'Le client {{customerName}} doit retourner le véhicule dans 2 heures.'
      },
      returnOverdue: {
        title: 'Retour en Retard - {{carMake}} {{carModel}}',
        message: 'Le client {{customerName}} n\'a pas retourné le véhicule. Le retour était prévu à {{returnTime}}.'
      },
      returnCritical: {
        title: 'URGENT: Retour en Retard - {{carMake}} {{carModel}}',
        message: 'Le client {{customerName}} a {{hoursOverdue}} heures de retard pour le retour du véhicule. Action immédiate requise.'
      },
      oilChange: {
        title: 'Vidange Due - {{carMake}} {{carModel}}',
        message: 'Le véhicule {{registrationNumber}} nécessite une vidange avant le {{dueDate}}.'
      },
      insuranceExpiry: {
        title: 'Assurance Expirante - {{carMake}} {{carModel}}',
        message: 'L\'assurance du véhicule {{registrationNumber}} expire le {{expiryDate}}. Veuillez renouveler bientôt.'
      },
      technicalControl: {
        title: 'Contrôle Technique Expirant - {{carMake}} {{carModel}}',
        message: 'Le contrôle technique du véhicule {{registrationNumber}} expire le {{expiryDate}}.'
      },
      bookingCompletion: {
        title: 'Réservation Doit Être Complétée',
        message: 'La réservation de {{clientName}} avec {{carInfo}} s\'est terminée le {{endDate}} mais est toujours marquée comme Confirmée. Veuillez mettre à jour le statut à Complété.'
      }
    }
  },
  
  // Car status management
  carStatuses: {
    updateInProgress: "Mise à jour des statuts des voitures...",
    updateComplete: "Statuts des voitures mis à jour avec succès",
    noUpdatesNeeded: "Tous les statuts des voitures sont à jour",
    updatedCount: "{{count}} voiture(s) mise(s) à jour",
    automaticUpdate: "Mise à jour automatique du statut des voitures",
    manualUpdate: "Mise à jour manuelle du statut des voitures",
    errorUpdating: "Erreur lors de la mise à jour des statuts des voitures"
  },
  
  // Browser notifications
  browserNotifications: {
    enable: 'Activer les Notifications',
    enabled: 'Notifications activées',
    permissionRequest: 'Permettre à KiraCar de vous envoyer des notifications pour les mises à jour importantes et les alertes.',
    permissionGranted: 'Notifications activées avec succès !',
    permissionDenied: 'Notifications désactivées',
    testTitle: 'Notifications KiraCar Activées',
    testMessage: 'Vous recevrez maintenant des notifications pour les mises à jour importantes !',
    testSuccess: 'Notification de test envoyée avec succès',
    testFailed: 'Échec de l\'envoi de la notification de test',
    test: 'Tester la Notification'
  },
  
  // Profile settings
  profile: {
    profile: 'Profil',
    security: 'Sécurité',
    preferences: 'Préférences',
    account: 'Compte',
    personalInfo: 'Informations personnelles',
    personalInfoDescription: 'Mettez à jour vos détails personnels et informations de contact',
    subtitle: 'Gérez les paramètres et préférences de votre compte',
    fullName: 'Nom complet',
    fullNamePlaceholder: 'Entrez votre nom complet',
    email: 'Adresse e-mail',
    emailCannotChange: "L'adresse e-mail ne peut pas être modifiée pour des raisons de sécurité",
    profilePicture: 'Photo de profil',
    phone: 'Numéro de téléphone',
    phonePlaceholder: 'Entrez votre numéro de téléphone',
    role: 'Rôle',
    roles: {
      admin: 'Administrateur',
      agency: 'Agence',
      customer: 'Client'
    },
    verified: 'Vérifié',
    noPhone: 'Aucun numéro de téléphone',
    avatarHelp: 'Cliquez pour télécharger une nouvelle photo de profil',
    changePassword: 'Changer le mot de passe',
    passwordHelp: 'Mettez à jour votre mot de passe pour sécuriser votre compte',
    currentPassword: 'Mot de passe actuel',
    newPassword: 'Nouveau mot de passe',
    confirmPassword: 'Confirmer le nouveau mot de passe',
    updatePassword: 'Mettre à jour le mot de passe',
    fillAllFields: 'Veuillez remplir tous les champs de mot de passe',
    passwordMismatch: 'Les nouveaux mots de passe ne correspondent pas',
    passwordTooShort: 'Le mot de passe doit contenir au moins 6 caractères',
    passwordChanged: 'Mot de passe mis à jour avec succès',
    passwordUpdateFailed: 'Échec de la mise à jour du mot de passe',
    currentPasswordRequired: 'Le mot de passe actuel est requis',
    newPasswordRequired: 'Le nouveau mot de passe est requis',
    confirmPasswordRequired: 'Veuillez confirmer votre nouveau mot de passe',
    incorrectCurrentPassword: 'Le mot de passe actuel est incorrect',
    fullNameRequired: 'Le nom complet est requis',
    invalidPhone: 'Numéro de téléphone invalide',
    language: 'Langue',
    languageHelp: 'Choisissez votre langue préférée',
    theme: 'Thème',
    themeHelp: 'Choisissez votre thème préféré',
    lightMode: 'Mode clair',
    darkMode: 'Mode sombre',
    systemMode: 'Système',
    notificationHelp: 'Activez les notifications du navigateur pour recevoir des mises à jour en temps réel sur les réservations, les paiements et la maintenance des véhicules.',
    accountInfo: 'Informations du compte',
    memberSince: 'Membre depuis',
    lastUpdated: 'Dernière mise à jour',
    notFound: 'Profil non trouvé'
  },
  
  // Success messages
  success: 'Succès',
  
  // Location-related translations for LocationSuggestionSelect
  locations: {
    searchResults: 'Résultats de recherche',
    popularLocations: 'Emplacements populaires',
    noResults: 'Aucun emplacement trouvé',
    addCustomLocation: 'Ajouter un emplacement personnalisé',
    locationName: 'Nom de l\'emplacement',
    address: 'Adresse',
    city: 'Ville',
    addLocation: 'Ajouter un emplacement',
    types: {
      airport: 'Aéroport',
      trainStation: 'Gare',
      port: 'Port',
      mall: 'Centre commercial',
      businessDistrict: 'Quartier d\'affaires',
      cityCenter: 'Centre-ville',
      city: 'Ville',
      district: 'Quartier',
      landmark: 'Point de repère'
    }
  },
  
  searching: 'Recherche en cours...',
  
  // Footer
  companyDescription: 'Votre partenaire de confiance pour des services de location de voitures premium. Nous offrons des solutions de transport fiables, abordables et pratiques.',
  quickLinks: 'Liens Rapides',
  forAgencies: 'Pour les Agences',
  joinAsAgency: 'Rejoindre en tant qu\'Agence',
  agencyHelp: 'Aide aux Agences',
  termsOfService: 'Conditions de Service',
  privacyPolicy: 'Politique de Confidentialité',
  allRightsReserved: 'Tous droits réservés',
  poweredByRichaDev: 'Propulsé par RichaDev',
  
  // Agency Details
  agencyDetails: 'Détails de l\'Agence',
  agencyNotFound: 'Agence non trouvée',
  businessStats: 'Statistiques d\'Affaires',
  totalVehicles: 'Total Véhicules',
  totalCars: 'Total Voitures',
  availableCars: 'Voitures Disponibles',
  agencyLocations: 'Emplacements',
  recentVehicles: 'Véhicules Récents',
  availableVehicles: 'Véhicules Disponibles',
  noVehiclesAvailable: 'Aucun véhicule disponible',
  noVehiclesForBrand: 'Il n\'y a actuellement aucun véhicule {{brand}} disponible à la location.',
  brandNotFound: 'Marque introuvable',
  brandNotFoundDesc: 'La marque demandée n\'existe pas ou n\'a pas de véhicules disponibles.',
  backToBrands: 'Retour aux marques',
  viewAllCars: 'Voir toutes les voitures',
  viewAllBrands: 'Voir toutes les marques',
  getDirections: 'Obtenir l\'Itinéraire',
  reviews: 'avis',
  discoverVehicles: 'Découvrez notre large gamme de véhicules et réservez votre location parfaite dès aujourd\'hui',
  daysLeft: 'jours restants',
  daysRemaining: 'jours restants',
  viewAll: 'Voir Tout',
  showInMap: 'Afficher sur la carte',
  mobileSearch: {
    trigger: 'Où aller ?',
    title: 'Trouvez votre voiture parfaite',
    description: 'Sélectionnez votre lieu et vos dates pour commencer.',
  },
  featuredCategories: 'Catégories en vedette',
  featuredCategoriesDesc: 'Vous savez ce que vous cherchez ? Parcourez notre vaste sélection de voitures',
  popularDestinations: 'Destinations Populaires',
  popularDestinationsDesc: 'Découvrez nos destinations les plus demandées pour votre prochaine location',
  carsFrom: 'Voitures à partir de',
  contactInfo: 'Informations de Contact',
  operatingHours: 'Heures d\'Ouverture',
  viewVehicles: 'Voir les Véhicules',
  callNow: 'Appeler Maintenant',
  sendEmail: 'Envoyer un Email',
  verified: 'Vérifié',
  memberSince: 'Membre depuis',
  pickupLocations: 'Lieux de Prise en Charge',
  main: 'Principal',
  closed: 'Fermé',
  
  // Days of the week
  monday: 'Lundi',
  tuesday: 'Mardi',
  wednesday: 'Mercredi',
  thursday: 'Jeudi',
  friday: 'Vendredi',
  saturday: 'Samedi',
  sunday: 'Dimanche',

  // Dashboard specific
  myBookings: 'Mes Réservations',
  all: 'Tout',
  searchBookings: 'Rechercher des réservations...',
  quickActions: 'Actions Rapides',
  contactAgency: 'Contacter l\'Agence',
  downloadContract: 'Télécharger le Contrat',

  // Booking Details Modal
  bookingDetails: 'Détails de la Réservation',
  vehicleInformation: 'Informations du Véhicule',
  agencyInformation: 'Informations de l\'Agence',
  bookingTimeline: 'Chronologie de la Réservation',
  bookingSummary: 'Résumé de la Réservation',
  bookingId: 'ID de Réservation',
  bookingDate: 'Date de Réservation',
  pickup: 'Prise en Charge',
  return: 'Retour',
  needHelp: 'Besoin d\'Aide?',
  contactSupportMessage: 'Si vous avez des questions concernant votre réservation, n\'hésitez pas à contacter notre équipe de support.',
  downloadInvoice: 'Télécharger la Facture',
  cancelBooking: 'Annuler la Réservation',
  confirmCancellation: 'Confirmer l\'annulation',
  cancelBookingConfirmation: 'Êtes-vous sûr de vouloir annuler votre réservation pour {{car}} chez {{agency}} ? Cette action ne peut pas être annulée.',
  keepBooking: 'Garder la réservation',
  failedToCancelBooking: 'Échec de l\'annulation de la réservation',
  bookingCancelledSuccessfully: 'Réservation annulée avec succès',
  bookingNotPending: 'Seules les réservations en attente peuvent être annulées',
  open24_7: 'Ouvert 24h/24',
  available24_7: 'Disponible 24 heures sur 24, 7 jours sur 7',
  reservedDates: 'Dates Réservées',
  favorites: {
    loginRequired: 'Connexion Requise',
    loginRequiredMessage: 'Vous devez être connecté pour ajouter des voitures à vos favoris. Veuillez vous connecter ou créer un compte pour sauvegarder vos voitures préférées.',
    addedToFavorites: 'Ajouté aux favoris',
    removedFromFavorites: 'Retiré des favoris',
    addToFavorites: 'Ajouter aux favoris',
    removeFromFavorites: 'Retirer des favoris',
    pageTitle: 'Mes Voitures Favorites',
    pageDescription: 'Consultez vos voitures favorites et gérez vos préférences',
    pageSubtitle: 'Voitures que vous avez ajoutées à vos favoris',
    errorTitle: 'Erreur lors du chargement des favoris',
    emptyTitle: 'Aucune voiture favorite pour le moment',
    emptyDescription: 'Commencez à explorer les voitures et ajoutez-les à vos favoris en cliquant sur l\'icône cœur.',
    browseCars: 'Parcourir les voitures',
    count: '{{count}} voiture(s) favorite(s)'
  },
  confirmDeletion: 'Confirmer la suppression',
  deleteBookingConfirmation: 'Êtes-vous sûr de vouloir supprimer définitivement votre réservation pour {{car}} chez {{agency}} ? Cette action ne peut pas être annulée.',
  failedToDeleteBooking: 'Échec de la suppression de la réservation',
  
  // Driver Information
  driverInformation: 'Informations du Conducteur',
  driverName: 'Nom du Conducteur',
  driverType: 'Type de Conducteur',
  identityCard: 'Carte d\'Identité',
  drivingPermit: 'Permis de Conduire',
  registeredCustomer: 'Client Enregistré',
  agencyClient: 'Client d\'Agence',
  
  // Additional Actions
  deleting: 'Suppression...',
  errorDeletingLocation: 'Erreur lors de la suppression de l\'emplacement',
}; 